import { render, staticRenderFns } from "./Vraag.vue?vue&type=template&id=4bb99e76&scoped=true&"
import script from "./Vraag.vue?vue&type=script&lang=js&"
export * from "./Vraag.vue?vue&type=script&lang=js&"
import style0 from "./Vraag.vue?vue&type=style&index=0&id=4bb99e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb99e76",
  null
  
)

export default component.exports